import { render, staticRenderFns } from "./ChallengeResultView.vue?vue&type=template&id=052fa12a&scoped=true&"
import script from "./ChallengeResultView.vue?vue&type=script&lang=js&"
export * from "./ChallengeResultView.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeResultView.vue?vue&type=style&index=0&id=052fa12a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052fa12a",
  null
  
)

/* custom blocks */
import block0 from "./ChallengeResultView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports